import { useLocalStorage } from "@/hooks/useLocalStorage";
import { Select, SelectItem } from "@nextui-org/react"

export const TypeCreateOrder = () => {
    const [selectedScreen, setSelectedScreen] = useLocalStorage<string>({
        key: 'selected-screen',
        defaultValue: 'OrderList',
      });
      
      const handleSelect = (event: any) => {
        const screen = event.target.value;
        setSelectedScreen(screen);
      };
    return (
        <Select
            value={selectedScreen}
            onChange={handleSelect}
            label="Tipo de orden"
            selectedKeys={selectedScreen ? [selectedScreen] : []}
            placeholder={"Selecciona tu tipo de orden"}
          >
            <SelectItem key="OrderList" value="OrderList">Lista</SelectItem>
            <SelectItem key="OrderSimple" value="OrderSimple">Botonera</SelectItem>
           </Select>
    )
}